// utils.js

// Function to convert interval string to milliseconds
// if the interval is not found, return 1h as default
export const intervalInMillis = (interval) => {
    const intervals = {
        '1m': 60 * 1000,        // 1 minute
        '5m': 5 * 60 * 1000,    // 5 minutes
        '15m': 15 * 60 * 1000,  // 15 minutes
        '30m': 30 * 60 * 1000,  // 30 minutes
        '1h': 60 * 60 * 1000,   // 1 hour
        '4h': 4 * 60 * 60 * 1000, // 4 hours
        '8h': 8 * 60 * 60 * 1000, // 8 hours
        '12h': 12 * 60 * 60 * 1000, // 12 hours
        '1d': 24 * 60 * 60 * 1000,  // 1 day
        '3d': 3 * 24 * 60 * 60 * 1000, // 3 days
        '1w': 7 * 24 * 60 * 60 * 1000  // 1 week
    };

    return intervals[interval] || intervals['1h'];
};

// Utility function to debounce a function call
export const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            func.apply(null, args);
        }, delay);
    };
};

// Function to format price with max 4 significant figures
export const formatPrice = (price) => {
    if (price === null || price === undefined) return price;
    const formattedPrice = parseFloat(price).toPrecision(5); // Up to 5 significant digits (including leading zeros)
    // If it's a very small number, format with scientific notation if needed
    return parseFloat(formattedPrice).toString();  // Ensure it's returned as a string
};